import { mapGetters, mapMutations } from 'vuex';
import dashboardPartnerData from '@/mixins/dashboardPartnerData.js';

export default {
  mixins: [dashboardPartnerData],
  computed: {
    ...mapGetters({
      shareLink: 'profile/invitation/shareLink'
    }),
    showInvitation() {
      return (
        this.partnerData.isFamilyAllowed &&
        !!this.$auth.user.benefit?.active &&
        this.$auth.user.invitation.host === null
      );
    },
    codeCopied: {
      get() {
        return this.$store.state.profile.invitation.codeCopied;
      },
      set(value) {
        this.$store.commit('profile/invitation/setCodeCopied', value);
      }
    },
    invitationMobileButtonSettings() {
      return {
        type: 'sendButton',
        props: {
          loading: false,
          'success-state': this.codeCopied,
          'button-text-success': this.$t('invitation.codeCopied')
        },
        events: {
          click: () => {
            this.copyCode();
          },
          reset: () => {
            this.codeCopied = false;
          }
        },
        text: this.$t('invitation.copyCode')
      };
    }
  },
  methods: {
    ...mapMutations({
      setShareLink: 'profile/invitation/setShareLink',
      setInvitationLoading: 'profile/invitation/setInvitationLoading'
    }),
    copyCode() {
      this.gtmPush({ event: 'invitation', 'event.detail': 'copy' });
      if (this.isMobileApp && this.isFlutterReady) {
        window.flutter_inappwebview.callHandler('copyToClipboard', { text: this.shareLink });
        this.codeCopied = true;
      } else {
        navigator.clipboard.writeText(this.shareLink).then(
          () => {
            this.codeCopied = true;
          },
          () => {
            console.warn('copy code error');
          }
        );
      }
    },
    getShareLink() {
      this.setInvitationLoading(true);
      this.$http
        .get('/v3/users/authorization/inviteLink')
        .then(data => {
          this.setShareLink(data.link);
        })
        .catch(err => {
          this.handleError({ error: err, code: '0x00000035' });
        })
        .finally(() => {
          this.setInvitationLoading(false);
        });
    }
  }
};
